"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileHeader = void 0;
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var React = __importStar(require("react"));
var Header_1 = require("../Header/Header");
var LayoutContext_1 = require("../LayoutContext");
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var useStyles = (0, makeStyles_1.default)(function (t) { return (0, createStyles_1.default)({
    header: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        boxShadow: t.shadows[3],
    },
    mock: {
        height: Header_1.headerHeight,
    },
}); });
var MobileHeader = function () {
    var classes = useStyles();
    var isMobileWidth = (0, LayoutContext_1.useLayoutContext)().isMobileWidth;
    return (React.createElement(material_1.Slide, { direction: "down", in: isMobileWidth, mountOnEnter: true, unmountOnExit: true },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.mock }),
            React.createElement(Header_1.Header, { className: classes.header }))));
};
exports.MobileHeader = MobileHeader;
//# sourceMappingURL=MobileHeader.js.map